<template>
    <a class="btn btn-default" href="#" @click="loginAction"><i v-bind:class="faIcon"></i> &nbsp; {{ text }}</a>
</template>

<script type="text/javascript">
    export default {
        props: ['faIcon', 'text', 'loginAction'],
        data: function() {
            return {};
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/login/social-login.vue